import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Theme from "./utils/theme";

if (typeof window !== "undefined" && !window.process) {
  window.process = { env: {} };
}

// The app is shown even when the theme colours can't load (no internet, the
// colour tool's site is down): with the default colours, after 4 s at most.
Promise.race([
  Theme.set(Theme.get()).catch(() => {}),
  new Promise((resolve) => setTimeout(resolve, 4000)),
]).then(function () {
  ReactDOM.render(
    <React.StrictMode>
      <App />,
    </React.StrictMode>,
    document.getElementById("root"),
  );
});

// unregister() removed every background script, also the push notification one
// that keeps the POS working offline; only an old unused one is removed now.
serviceWorker.unregisterOld();
